
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10Api from '@/api/f10Api'
export default defineComponent({
  components: { Table, Nodata },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      total: 0,
      pagination: {},
      spinning: true
    })
    pageData.total = computed(() => {
      return ((props.pageSourceData || {}).InvestActivity || {}).Total || 0
    })
    pageData.pagination = computed(() => {
      return {
        total: pageData.total,
        showSizeChanger: true,
        showTotal: (total: number) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: false,
        onChange: changeSize,
        onShowSizeChange: changeSize
      }
    })
    pageData.columns = [
      {
        title: '接待开始日',
        dataIndex: 'startDate',
        key: 'startDate',
        width: '100px'
      },
      {
        title: '接待截止日',
        dataIndex: 'endDate',
        key: 'endDate',
        width: '100px'
      },
      {
        title: '接待方式',
        dataIndex: 'MS',
        key: 'MS',
        width: '113px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '参与单位及人员',
        dataIndex: 'Participant',
        key: 'Participant',
        width: '357px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '活动地点',
        dataIndex: 'Place',
        key: 'Place',
        slots: { customRender: 'ellipsis' },
        width: '200px',
        ellipsis: true
      },
      {
        title: '上市公司接待人员',
        dataIndex: 'ListingCreper',
        key: 'ListingCreper',
        slots: { customRender: 'ellipsis' },
        width: '150px',
        ellipsis: true
      },
      {
        title: '活动纪要',
        dataIndex: 'LinkAddress',
        key: 'LinkAddress',
        slots: { customRender: 'download' },
        width: '100px',
        fixed: 'right'
      }
    ]
    onMounted(() => {
      getResearchDetail()
    })
    const route = useRoute()
    function getResearchDetail() {
      const data: any = {}
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getResearchDetail(data).then((res: any) => {
        const arr = res && res.Data
        if ((arr || []).length) {
          arr.forEach((item: any, i: number) => {
            item.index = 'ResearchDetail' + i
            item.startDate = window.moment(item.ReceptionDateS * 1000).format('YYYY-MM-DD')
            item.endDate = window.moment(item.ReceptionDateE * 1000).format('YYYY-MM-DD')
          })
        }
        pageData.data = arr || []
        nextTick(() => {
          pageData.spinning = false
        })
      })
    }
    function changeSize(current: number, size: number) {
      // getResearchDetail(current,size)
      nextTick(() => {
        const wrapper: any = document.querySelector('.wrapper')
        const target: any = document.getElementById('dyhd')
        wrapper.scrollTop = target.offsetTop
      })
    }
    return {
      ...toRefs(pageData)
    }
  }
})
